import React, { useState } from 'react'
import { styled } from '@mui/material/styles';

import { Link, useLocation, Navigate } from 'react-router-dom'
import { Button, TextField } from '@mui/material';
import LogoImage from "../../assets/images/Group5502-svg.svg";

    const StyledButton = styled(Button)(({ theme }) => ({
        color: '#fff',
        backgroundColor: '#003163',
        '&:hover': {
            backgroundColor: '#003163',
        },
    }));

    async function loginUser(credentials) {
        let loginFeedback = {"token":"test123"}
        // loginFeedback =  fetch('http://localhost:8080/login', {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify(credentials)
        // }).then(data => data.json());

        return loginFeedback
   }
   
   

   export default function Signup({ setToken }) {
    const location = useLocation();
    const localStorageToken = localStorage.getItem("isLoggedIn");

     const [username, setUserName] = useState();
     const [password, setPassword] = useState();
   
     const handleSubmit = async e => {
       e.preventDefault();
       const token = await loginUser({
         username,
         password
       });

       //setToken(token);
       setToken({"token":"test123"})
       location('/');
     }
   
     if(localStorageToken) return <Navigate to="/home"  replace />


     return(
        <div style={{width:'100%', display:'flex', justifyContent:'right', backgroundColor:'#FFFFFF'}}>
            <div style={{width:'50%',position:'relative'}}>
                <div style={{ 
                    margin: 'auto',
                    textAlign: 'center', 
                    width: '50%',  
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    height:237}}>
                        <img style={{borderRadius: '5px'}} src={LogoImage} width={340} height={237}/>
                </div>
            </div>
            <div style={{ position:'relative',height:600, width:610, backgroundColor:'#E5F2FB'}}>
                    <div style={{ 
                    margin: 'auto',
                    // textAlign: 'end', 
                    width: '50%',  
                    position: 'absolute',
                    top: '30%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    height:237}}>
                        
                        <div className="login-wrapper">
                            <h1>Sign Up</h1>
                            <form onSubmit={handleSubmit}>
                                <TextField size='small' label="First Name" variant="outlined"
                                    sx={{ marginTop:'15px',marginBottom:'15px',width:'300px', borderRadius:'20px'}}
                                />
                                <TextField size='small' label="Last Name" variant="outlined"
                                    sx={{ marginBottom:'15px',width:'300px' }}
                                />
                                    <TextField size='small' label="Email Address" variant="outlined"
                                    sx={{ marginBottom:'15px',width:'300px', borderRadius:'20px'}}
                                />
                                <TextField size='small' label="User Name" variant="outlined"
                                    sx={{ marginBottom:'15px',width:'300px' }}
                                />
                                <TextField size='small' label="Password" variant="outlined"
                                    sx={{ marginBottom:'15px',width:'300px' }}
                                />
                                    <TextField size='small' label="Re-entered Password" variant="outlined"
                                    sx={{ marginBottom:'25px',width:'300px' }}
                                />
                                
                                <div style={{display:'flex',marginBottom:'15px', justifyContent:'space-between'}}>
                                    <div style={{fontSize:'11px'}}> 
                                        Already a user? 
                                        <Link to='/login' onClick={()=> location('/login')}>
                                                Login
                                        </Link>
                                    </div>
                                    
                                </div>
                            <div >
                                <StyledButton  sx={{width:'300px'}}
                                type="submit">Sign Up</StyledButton>
                            </div>
                            </form>
                        </div>
                    </div>
            </div>
        </div>
    
     )
   }
   
  